module.exports = __webpack_public_path__ + "img/priceiq.1328735f.png";